/* eslint-disable @typescript-eslint/no-explicit-any */

const filterPages = (visiblePages: any, totalPages: any) => {
  return visiblePages.filter((page: any) => page <= totalPages);
};

export const getVisiblePages = (page: any, total: any) => {
  if (!page && !total) {
    return [1];
  }
  if (page === 0 && total === 0) {
    return [1];
  }
  if (total < 7) {
    return filterPages([1, 2, 3, 4, 5, 6], total);
  } else {
    if (page % 5 >= 0 && page > 4 && page + 2 < total) {
      return [1, page - 1, page, page + 1, total];
    } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
      return [1, total - 3, total - 2, total - 1, total];
    } else {
      return [1, 2, 3, 4, 5, total];
    }
  }
};

export const getTotalItemView = (
  totalItems: any,
  pageSize: any,
  pageIndex: any
) => {
  pageIndex++;
  if (pageIndex * pageSize - pageSize > totalItems.countByFilter) {
    pageIndex = 1;
  }
  const from =
    pageIndex * pageSize - pageSize + 1 > totalItems.countByFilter
      ? 0
      : pageIndex * pageSize - pageSize + 1;
  const to =
    pageIndex * pageSize < totalItems.countByFilter
      ? pageIndex * pageSize
      : totalItems.countByFilter;

  return { from: from, to: to };
};
